export class Artikel {
    public ATArtikelnummer: string;
    public ATVariante: string ;
    public ATEANNummer: string;
    public ATBezeichnung1: string;
    public ATBezeichnung2: string;
    public ATSuchbegriff: string;
    public ATGUID: string;
    public ATMass: string;
    public ATKilo: number;
    public ATArtikelgruppe: string;
    public ATBuchungseinheit: string;

    public ATVPETransport: string;
    public ATHoehe_Pal: number;
    public ATLsiLHMBestand: number;

    public ATVPEMenge: number;
    public ATVPE: string;
    public ATLsiVPEBestand: number;

    public ATVPEInhalt: number;
    public ATLsiLagerBestand: number;
    public ATLagerME: string;        
 

    constructor() {
    }

}


// WEBPACK FOOTER //
// D:/Crossplatform/swsLagerinfo/src/app/models/artikel.model.ts